import { Component, Inject } from '@angular/core';
import { ModalController } from '@ionic/angular';
import Env from '@ridango/core/env';
import { AndroidSettings, IOSSettings, NativeSettings } from 'capacitor-native-settings';

@Component({
    selector: 'rwidget-permission-notification-modal',
    templateUrl: './permission-notification-modal.component.html',
    styleUrls: ['./permission-notification-modal.component.scss']
})
export class PermissionNotificationModalComponent {
    constructor(
        private modalCtrl: ModalController,
        @Inject('ENV') public env: Env
    ) {}

    public async openDeviceSetting() {
        await NativeSettings.open({
            optionAndroid: AndroidSettings.AppNotification,
            optionIOS: IOSSettings.App
        });
        this.cancel();
    }

    public async cancel(): Promise<void> {
        await this.modalCtrl.dismiss(null, 'cancel');
    }
}
